"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSaveResponse = void 0;

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var _modelBuilders = require("../../../../utils/model-builders");

/*
  Sample XML Response:
    <SaveScannerResponse>
      <SaveScannerResult>
        <ASResult>0</ASResult>
        <ASMessage></ASMessage>
      </SaveScannerResult>
      <Scannerid>10</Scannerid>
    </SaveScannerResponse>
*/
var createSaveResponse = function createSaveResponse(method, property) {
  return function (raw) {
    return (0, _modelBuilders.parseModel)(raw, {
      result: {
        path: method + 'Result[0]',
        model: _genericAsResultHeader.genericAsResultHeader
      },
      response: {
        type: Number,
        path: property
      }
    });
  };
};

exports.createSaveResponse = createSaveResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/users/response-parsers/save-response.js
// module id = 212
// module chunks = 0